/**
 * @generated SignedSource<<8b7a86ed570e1710e3b96774dd68b700>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type DateInlineEditCell$data = {
  readonly __typename: string;
  readonly date?: AGG$Date | null | undefined;
  readonly dateTime?: AGG$DateTime | null | undefined;
  readonly fieldId: string;
  readonly " $fragmentSpreads": FragmentRefs<"DateInlineEditCell_DateInlineEditCell">;
  readonly " $fragmentType": "DateInlineEditCell";
};
export type DateInlineEditCell$key = {
  readonly " $data"?: DateInlineEditCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"DateInlineEditCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "DateInlineEditCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "date"
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "isInlineEditingEnabled",
              "variableName": "isInlineEditingEnabled"
            }
          ],
          "kind": "FragmentSpread",
          "name": "DateInlineEditCell_DateInlineEditCell"
        }
      ],
      "type": "JiraDatePickerField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "dateTime"
        }
      ],
      "type": "JiraDateTimePickerField"
    }
  ],
  "type": "JiraIssueField",
  "abstractKey": "__isJiraIssueField"
};

(node as any).hash = "08f283612324c48c575ea0eab88bb740";

export default node;
